module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Lucens_COA-f98289d7e830725f017ba3718af8d014.svg";